import React from 'react'
import { l } from '@manychat/manyui'

import { PreviewComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/PreviewComponent/PreviewComponent'
import { EmailContentWrapper } from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/components/EmailContentWrapper/EmailContentWrapper'
import {
  ATTACHMENT_DEFAULT_WIDTH_MODIFIER,
  AttachmentWidthModifierMap,
  EMAIL_CONTENT_BLOCK_HORIZONTAL_PADDING,
} from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/styleConstants'
import { EmailContentComponent } from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { EmailContentPreview } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

import * as styles from './EmailContentPreview.styles'

const PREVIEW_WIDTH =
  DEFAULT_NODE_WIDTH -
  sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2 -
  EMAIL_CONTENT_BLOCK_HORIZONTAL_PADDING * 2

export const EmailContentPreviewComponent: EmailContentComponent<EmailContentPreview> = (props) => {
  const { size, preview, buttons } = props.content.data
  const widthModifier = AttachmentWidthModifierMap[size] || ATTACHMENT_DEFAULT_WIDTH_MODIFIER

  return (
    <EmailContentWrapper>
      <PreviewComponent
        url={preview.url}
        size={preview.size}
        targetWidth={PREVIEW_WIDTH * widthModifier}
      />
      {buttons.length > 0 && (
        <>
          <view style={styles.LabelContainerStyle}>
            <richtext style={styles.LabelStyle} text={l.translate('When click this image')} />
          </view>
          {buttons.map((button) => (
            <Button key={button.id} button={button} />
          ))}
        </>
      )}
    </EmailContentWrapper>
  )
}
